var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"visible-lg wrap-header"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"lg-3"},[_c('Logo')],1),_c('div',{staticClass:"lg-8 offset-lg-1"},[_c('Menu')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }